import React from "react"

function formatDelta(t, kind, value) {
  if (value == null) return "—"
  const sign = value > 0 ? "+" : value < 0 ? "−" : ""
  const abs = Math.abs(value)
  if (kind === "pp") return t("dashboard.overview.pp_delta", { sign, value: abs.toFixed(1) })
  return t("dashboard.overview.percent_delta", { sign, value: abs })
}

function deltaClass(value) {
  if (value == null || value === 0) return "text-ink-tertiary"
  return value > 0 ? "text-winner" : "text-negative"
}

function MetricCell({ label, value, delta }) {
  return (
    <div className="px-6 first:pl-0 last:pr-0 border-r border-rule last:border-r-0 flex flex-col gap-2">
      <span
        className="font-mono text-[10px] text-ink-tertiary"
        style={{ letterSpacing: "0.10em" }}
      >
        {label}
      </span>
      <span
        className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {value}
      </span>
      {delta != null && (
        <span
          className={`text-[13px] font-medium ${deltaClass(delta.raw)}`}
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {delta.text}
        </span>
      )}
    </div>
  )
}

export default function MetricStrip({ t, metrics }) {
  if (!metrics) return null

  const visits = metrics.visits ?? 0
  const conversions = metrics.conversions ?? 0
  const running = metrics.running_experiments ?? 0
  const visitsDelta = metrics.visits_delta_percent

  return (
    <div
      className="grid grid-cols-3 gap-0 py-[18px] border-t"
      style={{ borderTopWidth: 1, borderTopColor: "#0F172A", borderBottom: "1px solid #E2E8F0" }}
    >
      <MetricCell
        label={t("dashboard.overview.metric_visits")}
        value={visits.toLocaleString("en-US")}
        delta={visitsDelta == null ? null : {
          raw: visitsDelta,
          text: formatDelta(t, "percent", visitsDelta)
        }}
      />
      <MetricCell
        label={t("dashboard.overview.metric_conversions")}
        value={conversions.toLocaleString("en-US")}
      />
      <MetricCell
        label={t("dashboard.overview.metric_running")}
        value={running.toLocaleString("en-US")}
      />
    </div>
  )
}
